import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";

const CreditDisabled = ({ t }: WithTranslation) => {
    return (
        <>
            <p className="StepOne__title">{t("ContinueDeal.StepOne.CreditDisabled.title")}</p>
            <p className="StepOne__text">{t("ContinueDeal.StepOne.CreditDisabled.description")}</p>
        </>
    );
};

export default withTranslation()(CreditDisabled);
